<template>
  <div class="number-field__container">
    <div
      v-if="hasError === true"
      class="ui negative small message">
      <div>
        Please key in a number.
      </div>
    </div>

    <div class="ui right labeled input">
      <input
        :max="max"
        :min="min"
        v-model.number="selectedValueModel"
        type="number"
        class="input--number input--number-detached"
        :readonly="readOnly"
        @change="setSelectedValue">
      <label
        v-if="question.hasOwnProperty('properties')"
        class="ui label">{{ question.properties.units }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberField',
  props: {
    readOnly: {
      type: Boolean,
      default: true
    },
    question: {
      type: Object,
      required: true,
      default: function () {
        return null
      }
    },
    answer: {
      type: null,
      required: false,
      default: function () {
        return {
          number: null
        }
      }
    }
  },
  data () {
    return {
      selectedValueModel: null,
      hasError: false,
      buttonIsVisible: false
    }
  },
  computed: {
    questionId: function () {
      return this.question.id
    },
    selectedValue: function () {
      let selectedValue = null
      if (this.answer.number !== '' || this.answer.number !== undefined || this.answer.number !== null) {
        selectedValue = this.answer.number
      }
      return selectedValue
    },
    max: function () {
      return this.question.validations.max_value || 100
    },
    min: function () {
      return this.question.validations.min_value || 0
    },
    buildAnswerFormat: function () {
      let answer = {
        'type': 'number',
        'number': this.selectedValueModel,
        'field': {
          'id': this.questionId,
          'type': 'number'
        }
      }
      return answer
    }
  },
  watch: {
    selectedValueModel (newValue) {
      if (this.hasError && (newValue !== '' || !isNaN(newValue))) {
        this.setAnswer()
      }
    },
    selectedValue (value) {
      if (value) {
        this.selectedValueModel = this.selectedValue
      }
    }
  },
  mounted () {
    if (this.selectedValue !== undefined && this.selectedValue !== null && this.selectedValue !== '') { // selectedValueModel = selectedValue
      this.selectedValueModel = this.selectedValue
    }
  },
  deactivated () {
    this.selectedValueModel = null
    this.hasError = false
  },
  methods: {
    isAnswerValid: function () {
      return new Promise((resolve, reject) => {
        this.hasError = false
        if (!this.questionId || this.selectedValueModel === undefined || this.selectedValueModel === null || this.selectedValueModel === '') {
          this.hasError = true
          this.$emit('invalidAnswer')
        } else if (this.selectedValueModel > this.max) {
          this.hasError = true
          this.$emit('invalidAnswer')
        } else if (this.selectedValueModel < this.min) {
          this.hasError = true
          this.$emit('invalidAnswer')
        }
        resolve()
      })
    },
    setAnswer: function () {
      this.isAnswerValid()
        .then(
          () => {
            this.setSelectedValue()
          },
          error => {

          }
        )
    },
    setSelectedValue: function () {
      if (this.$route.name !== 'ReadOnlyAssessment') {
        this.$emit('save', this.buildAnswerFormat)
      }
    }
  }
}
</script>

<style scoped>
.number-field__container {
  width: 100%;
  margin: 0.875rem 0;
}
input.input--number {
  min-width: 8rem !important;
}
input.input--number.input--number-detached {
  border-right-color: #e8e8e8 !important;
}
input.input--number.input--number-detached:focus {
  border-right-color: #85b7d9 !important;
}
</style>
